import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M4.961 1.334h8.078a2 2 0 0 1 1.562.75l1.712 2.141a2 2 0 0 1-.025 2.53l-5.751 6.901a2 2 0 0 1-3.073 0L1.712 6.755a2 2 0 0 1-.025-2.53L3.4 2.085a2 2 0 0 1 1.561-.751M1.5 5.5h15M9 14.25 5.667 5.5M9 14.25l3.333-8.75"
    }, null, -1)
  ])))
}
export default { render: render }